// src/utils/isType.ts
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var OBJECT = "object";
var FUNCTION = "function";
var isFunction = function(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === FUNCTION;
};
var isObject = function(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === OBJECT;
};
var isPlainObject = function(value) {
    return !!value && Object.prototype.toString.call(value) === "[object Object]";
};
var isString = function(value) {
    return typeof value === "string";
};
// src/utils/serialize.ts
var JSON_UNDEFINED = "__JSON_UNDEFINED__";
var replacer = function(_key, value) {
    return value === void 0 ? JSON_UNDEFINED : value;
};
var reviver = function(_key, value) {
    if (isObject(value)) {
        var keys = Object.keys(value);
        for(var i = keys.length; i-- > 0;){
            var key = keys[i];
            if (value[key] === JSON_UNDEFINED) {
                value[key] = void 0;
            }
        }
    }
    return value;
};
var stringifyState = function(value) {
    return JSON.stringify(value, replacer);
};
var parseState = function(value) {
    return JSON.parse(value, value.indexOf(JSON_UNDEFINED) >= 0 ? reviver : void 0);
};
// src/utils/deepEqual.ts
var deepEqual = function(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : _type_of(a)) == OBJECT && (typeof b === "undefined" ? "undefined" : _type_of(b)) == OBJECT) {
        if (a.constructor !== b.constructor) return false;
        var i;
        var len;
        var key;
        if (Array.isArray(a)) {
            len = a.length;
            if (len != b.length) return false;
            for(i = len; i-- > 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        var keys = Object.keys(a);
        len = keys.length;
        if (len !== Object.keys(b).length) return false;
        for(i = len; i-- > 0;){
            if (!hasOwn.call(b, keys[i])) return false;
        }
        for(i = len; i-- > 0;){
            key = keys[i];
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};
var hasOwn = Object.prototype.hasOwnProperty;
// src/store/modelStore.ts
import { applyMiddleware, compose, legacy_createStore as createStore2 } from "redux";
import { Topic } from "topic";
// src/actions/refresh.ts
var TYPE_REFRESH_STORE = "@@store/refresh";
var actionRefresh = function(force) {
    return {
        type: TYPE_REFRESH_STORE,
        payload: {
            force: force
        }
    };
};
var isRefreshAction = function(action) {
    return action.type === TYPE_REFRESH_STORE;
};
// src/actions/model.ts
var isPreModelAction = function(action) {
    var test = action;
    return test.preModel && !!test.model && isFunction(test.consumer);
};
var isPostModelAction = function(action) {
    var test = action;
    return test.postModel && !!test.next;
};
// src/utils/immer.ts
import { Immer, enableES5 } from "immer";
enableES5();
var immer = new Immer({
    autoFreeze: false
});
// src/middleware/modelInterceptor.ts
var modelInterceptor = function(api) {
    return function(dispatch2) {
        return function(action) {
            if (!isPreModelAction(action)) {
                return dispatch2(action);
            }
            var prev = api.getState()[action.model];
            var next = immer.produce(prev, function(draft) {
                return action.consumer(draft, action);
            });
            action.actionInActionGuard && action.actionInActionGuard();
            if (deepEqual(prev, next)) return action;
            return dispatch2({
                type: action.type,
                model: action.model,
                postModel: true,
                next: next
            });
        };
    };
};
// src/actions/persist.ts
var TYPE_PERSIST_HYDRATE = "@@persist/hydrate";
var actionHydrate = function(states) {
    return {
        type: TYPE_PERSIST_HYDRATE,
        payload: states
    };
};
var isHydrateAction = function(action) {
    return action.type === TYPE_PERSIST_HYDRATE;
};
// src/utils/to-promise.ts
var toPromise = function(fn) {
    return Promise.resolve().then(fn);
};
// src/persist/PersistItem.ts
var defaultDumpOrLoadFn = function(value) {
    return value;
};
var PersistItem = /*#__PURE__*/ function() {
    "use strict";
    function PersistItem(options) {
        this.options = options;
        this.records = {};
        var models = options.models, _options_keyPrefix = options.keyPrefix, keyPrefix = _options_keyPrefix === void 0 ? "@@foca.persist:" : _options_keyPrefix, key = options.key, _options_merge = options.merge, merge = _options_merge === void 0 ? "merge" : _options_merge;
        this.key = keyPrefix + key;
        for(var i = models.length; i-- > 0;){
            var model = models[i];
            var _ref = model._$opts.persist || {}, _ref_load = _ref.load, load = _ref_load === void 0 ? defaultDumpOrLoadFn : _ref_load, _ref_dump = _ref.dump, dump = _ref_dump === void 0 ? defaultDumpOrLoadFn : _ref_dump, tmp = _ref.version, customVersion = tmp === void 0 ? 0 : tmp, tmp1 = _ref.merge, customMerge = tmp1 === void 0 ? merge : tmp1;
            this.records[model.name] = {
                model: model,
                opts: {
                    version: customVersion,
                    merge: customMerge,
                    load: load,
                    dump: dump,
                    ctx: model._$persistCtx
                }
            };
        }
    }
    var _proto = PersistItem.prototype;
    _proto.init = function init() {
        var _this = this;
        return toPromise(function() {
            return _this.options.engine.getItem(_this.key);
        }).then(function(data) {
            if (!data) {
                _this.loadMissingState();
                return _this.dump();
            }
            try {
                var schema = JSON.parse(data);
                if (!_this.validateSchema(schema)) {
                    _this.loadMissingState();
                    return _this.dump();
                }
                var schemaKeys = Object.keys(schema.d);
                for(var i = schemaKeys.length; i-- > 0;){
                    var key = schemaKeys[i];
                    var record = _this.records[key];
                    if (record) {
                        var opts = record.opts;
                        var itemSchema = schema.d[key];
                        if (_this.validateItemSchema(itemSchema, opts)) {
                            var dumpData = parseState(itemSchema.d);
                            record.prev = _this.merge(opts.load.call(opts.ctx, dumpData), opts.ctx.initialState, opts.merge);
                            record.schema = itemSchema;
                        }
                    }
                }
                _this.loadMissingState();
                return _this.dump();
            } catch (e) {
                _this.dump();
                throw e;
            }
        });
    };
    _proto.loadMissingState = function loadMissingState() {
        var _this = this;
        this.loop(function(record) {
            var prev = record.prev, opts = record.opts, schema = record.schema;
            if (!schema || !prev) {
                var dumpData = opts.dump.call(null, opts.ctx.initialState);
                record.prev = _this.merge(opts.load.call(opts.ctx, dumpData), opts.ctx.initialState, opts.merge);
                record.schema = {
                    v: opts.version,
                    d: stringifyState(dumpData)
                };
            }
        });
    };
    _proto.merge = function merge(persistState, initialState, mode) {
        var isStateArray = Array.isArray(persistState);
        var isInitialStateArray = Array.isArray(initialState);
        if (isStateArray && isInitialStateArray) return persistState;
        if (isStateArray || isInitialStateArray) return initialState;
        if (mode === "replace") return persistState;
        var state = Object.assign({}, initialState, persistState);
        if (mode === "deep-merge") {
            var keys = Object.keys(persistState);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (Object.prototype.hasOwnProperty.call(initialState, key) && isPlainObject(state[key]) && isPlainObject(initialState[key])) {
                    state[key] = Object.assign({}, initialState[key], state[key]);
                }
            }
        }
        return state;
    };
    _proto.collect = function collect() {
        var stateMaps = {};
        this.loop(function(param, key) {
            var state = param.prev;
            state && (stateMaps[key] = state);
        });
        return stateMaps;
    };
    _proto.update = function update(nextState) {
        var changed = false;
        this.loop(function(record) {
            var model = record.model, prev = record.prev, opts = record.opts, schema = record.schema;
            var nextStateForKey = nextState[model.name];
            if (nextStateForKey !== prev) {
                record.prev = nextStateForKey;
                var nextSchema = {
                    v: opts.version,
                    d: stringifyState(opts.dump.call(null, nextStateForKey))
                };
                if (!schema || nextSchema.d !== schema.d) {
                    record.schema = nextSchema;
                    changed || (changed = true);
                }
            }
        });
        changed && this.dump();
    };
    _proto.loop = function loop(callback) {
        var records = this.records;
        var recordKeys = Object.keys(records);
        for(var i = recordKeys.length; i-- > 0;){
            var key = recordKeys[i];
            callback(records[key], key);
        }
    };
    _proto.dump = function dump() {
        this.options.engine.setItem(this.key, JSON.stringify(this.toJSON()));
    };
    _proto.validateSchema = function validateSchema(schema) {
        return isObject(schema) && isObject(schema.d) && schema.v === this.options.version;
    };
    _proto.validateItemSchema = function validateItemSchema(schema, options) {
        return schema && schema.v === options.version && isString(schema.d);
    };
    _proto.toJSON = function toJSON() {
        var states = {};
        this.loop(function(param, key) {
            var schema = param.schema;
            schema && (states[key] = schema);
        });
        return {
            v: this.options.version,
            d: states
        };
    };
    return PersistItem;
}();
// src/persist/PersistManager.ts
var PersistManager = /*#__PURE__*/ function() {
    "use strict";
    function PersistManager(options) {
        this.initialized = false;
        this.list = options.map(function(option) {
            return new PersistItem(option);
        });
    }
    var _proto = PersistManager.prototype;
    _proto.init = function init(store, hydrate) {
        var _this = this;
        this.unsubscribeStore = store.subscribe(function() {
            _this.initialized && _this.update(store);
        });
        return Promise.all(this.list.map(function(item) {
            return item.init();
        })).then(function() {
            hydrate && store.dispatch(actionHydrate(_this.collect()));
            _this.initialized = true;
        });
    };
    _proto.destroy = function destroy() {
        this.unsubscribeStore();
        this.initialized = false;
    };
    _proto.collect = function collect() {
        return this.list.reduce(function(stateMaps, item) {
            return Object.assign(stateMaps, item.collect());
        }, {});
    };
    _proto.combineReducer = function combineReducer(original2) {
        return function(state, action) {
            if (state === void 0) state = {};
            if (isHydrateAction(action)) {
                return Object.assign({}, state, action.payload);
            }
            return original2(state, action);
        };
    };
    _proto.update = function update(store) {
        var _this = this;
        this.timer || (this.timer = setTimeout(function() {
            var nextState = store.getState();
            _this.timer = void 0;
            for(var i = _this.list.length; i-- > 0;){
                _this.list[i].update(nextState);
            }
        }, 50));
    };
    return PersistManager;
}();
// src/store/proxyStore.ts
import { legacy_createStore as createStore } from "redux";
var proxyStore = createStore(function() {
    return {};
});
var dispatch = function() {
    proxyStore.dispatch({
        type: "-"
    });
};
var combine = function(otherStore) {
    otherStore.subscribe(dispatch);
};
// src/utils/symbolObservable.ts
var $$observable = (typeof Symbol === "undefined" ? "undefined" : _type_of(Symbol)) === FUNCTION && Symbol.observable || "@@observable";
// src/store/StoreBasic.ts
var _a;
var StoreBasic = /*#__PURE__*/ function() {
    "use strict";
    function StoreBasic() {
        var _this = this;
        this.origin = null;
        this.dispatch = function(action) {
            return _this.store.dispatch(action);
        };
        this.getState = function() {
            return _this.store.getState();
        };
        this.subscribe = function(listener) {
            return _this.store.subscribe(listener);
        };
        this[_a] = function() {
            return _this.store[$$observable]();
        };
    }
    _create_class(StoreBasic, [
        {
            key: "store",
            get: function get() {
                if (!this.origin) {
                    throw new Error("[store] 当前无实例，忘记执行'store.init()'了吗？");
                }
                return this.origin;
            }
        }
    ]);
    return StoreBasic;
}();
_a = $$observable;
// src/middleware/actionInActionInterceptor.ts
var actionInActionInterceptor = function() {
    var dispatching = false;
    var prevAction = null;
    return function(dispatch2) {
        return function(action) {
            if (!isPreModelAction(action)) {
                return dispatch2(action);
            }
            if (dispatching) {
                throw new Error("[dispatch] 派发任务冲突，请检查是否在reducers函数中直接或者间接执行了其他reducers或者methods函数。\nreducers的唯一职责是更新当前的state，有额外的业务逻辑时请把methods作为执行入口并按需调用reducers。\n\n当前冲突的reducer：\n\n" + JSON.stringify(action, null, 4) + "\n\n上次执行未完成的reducer：\n\n" + JSON.stringify(prevAction, null, 4) + "\n\n");
            }
            try {
                dispatching = true;
                prevAction = action;
                action.actionInActionGuard = function() {
                    dispatching = false;
                    prevAction = null;
                };
                return dispatch2(action);
            } catch (e) {
                prevAction = null;
                dispatching = false;
                throw e;
            }
        };
    };
};
// src/middleware/freezeStateMiddleware.ts
import { freeze } from "immer";
var freezeStateMiddleware = function(api) {
    freeze(api.getState(), true);
    return function(dispatch2) {
        return function(action) {
            try {
                return dispatch2(action);
            } finally{
                freeze(api.getState(), true);
            }
        };
    };
};
// src/store/modelStore.ts
var ModelStore = /*#__PURE__*/ function(StoreBasic) {
    "use strict";
    _inherits(ModelStore, StoreBasic);
    function ModelStore() {
        var _this;
        _this = StoreBasic.call(this) || this;
        _this.topic = new Topic();
        _this._isReady = false;
        _this.consumers = {};
        _this.reducerKeys = [];
        _this.persister = null;
        _this.topic.keep("ready", function() {
            return _this._isReady;
        });
        return _this;
    }
    var _proto = ModelStore.prototype;
    _proto.init = function init(options) {
        if (options === void 0) options = {};
        var _this = this;
        var prevStore = this.origin;
        var firstInitialize = !prevStore;
        if (!firstInitialize) {
            if (process.env.NODE_ENV === "production") {
                throw new Error("[store] 请勿多次执行'store.init()'");
            }
        }
        this._isReady = false;
        this.reducer = this.combineReducers();
        var persistOptions = options.persist;
        var persister = this.persister;
        persister && persister.destroy();
        if (persistOptions && persistOptions.length) {
            persister = this.persister = new PersistManager(persistOptions);
            this.reducer = persister.combineReducer(this.reducer);
        } else {
            persister = this.persister = null;
        }
        var store;
        if (firstInitialize) {
            var middleware = (options.middleware || []).concat(modelInterceptor);
            if (process.env.NODE_ENV !== "production") {
                middleware.unshift(actionInActionInterceptor);
                middleware.push(freezeStateMiddleware);
            }
            var enhancer = applyMiddleware.apply(null, middleware);
            store = this.origin = createStore2(this.reducer, options.preloadedState, this.getCompose(options.compose)(enhancer));
            this.topic.publish("init");
            combine(store);
        } else {
            store = prevStore;
            store.replaceReducer(this.reducer);
        }
        if (persister) {
            persister.init(store, firstInitialize).then(function() {
                _this.ready();
            });
        } else {
            this.ready();
        }
        return this;
    };
    _proto.refresh = function refresh(force) {
        if (force === void 0) force = false;
        var action = this.dispatch(actionRefresh(force));
        this.topic.publish("refresh");
        return action;
    };
    _proto.unmount = function unmount() {
        this.origin = null;
        this._isReady = false;
        this.topic.publish("unmount");
    };
    _proto.onInitialized = function onInitialized(maybeSync) {
        var _this = this;
        return new Promise(function(resolve) {
            if (_this._isReady) {
                maybeSync && maybeSync();
                resolve();
            } else {
                _this.topic.subscribeOnce("ready", function() {
                    maybeSync && maybeSync();
                    resolve();
                });
            }
        });
    };
    _proto.ready = function ready() {
        this._isReady = true;
        this.topic.publish("ready");
    };
    _proto.getCompose = function getCompose(customCompose) {
        if (customCompose === "redux-devtools") {
            if (process.env.NODE_ENV !== "production") {
                return /** @ts-expect-error */ ((typeof window === "undefined" ? "undefined" : _type_of(window)) === OBJECT ? window : (typeof global === "undefined" ? "undefined" : _type_of(global)) === OBJECT ? global : {})["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
            }
            return compose;
        }
        return customCompose || compose;
    };
    _proto.combineReducers = function combineReducers() {
        var _this = this;
        return function(state, action) {
            if (state === void 0) {
                state = {};
            }
            var reducerKeys = _this.reducerKeys;
            var consumers = _this.consumers;
            var keyLength = reducerKeys.length;
            var nextState = {};
            var hasChanged = false;
            var i = keyLength;
            while(i-- > 0){
                var key = reducerKeys[i];
                var prevForKey = state[key];
                var nextForKey = nextState[key] = consumers[key](prevForKey, action);
                hasChanged || (hasChanged = nextForKey !== prevForKey);
            }
            return hasChanged || keyLength !== Object.keys(state).length ? nextState : state;
        };
    };
    ModelStore.appendReducer = function appendReducer(key, consumer) {
        var store = this.origin;
        var consumers = this.consumers;
        var exists = store && consumers.hasOwnProperty(key);
        consumers[key] = consumer;
        this.reducerKeys = Object.keys(consumers);
        store && !exists && store.replaceReducer(this.reducer);
    };
    ModelStore.removeReducer = function removeReducer(key) {
        var store = this.origin;
        var consumers = this.consumers;
        if (consumers.hasOwnProperty(key)) {
            delete consumers[key];
            this.reducerKeys = Object.keys(consumers);
            store && store.replaceReducer(this.reducer);
        }
    };
    _create_class(ModelStore, [
        {
            key: "isReady",
            get: function get() {
                return this._isReady;
            }
        }
    ]);
    return ModelStore;
}(StoreBasic);
var modelStore = new ModelStore();
// src/utils/toArgs.ts
var slice = Array.prototype.slice;
var toArgs = function(args, start) {
    return slice.call(args, start);
};
// src/model/enhanceAction.ts
var enhanceAction = function(ctx, actionName, consumer) {
    var modelName = ctx.name;
    var actionType = modelName + "." + actionName;
    var enhancedConsumer = function(state, action) {
        return consumer.apply(ctx, [
            state
        ].concat(action.payload));
    };
    var fn = function fn() {
        return modelStore.dispatch({
            type: actionType,
            model: modelName,
            preModel: true,
            payload: toArgs(arguments),
            consumer: enhancedConsumer
        });
    };
    return fn;
};
// src/actions/loading.ts
var TYPE_SET_LOADING = "@@store/loading";
var LOADING_CATEGORY = "##" + Math.random();
var DESTROY_LOADING = TYPE_SET_LOADING + "/destroy";
var isLoadingAction = function(action) {
    var tester = action;
    return tester.type === TYPE_SET_LOADING && !!tester.model && !!tester.method && !!tester.payload;
};
var isDestroyLoadingAction = function(action) {
    var tester = action;
    return tester.type === DESTROY_LOADING && !!tester.model;
};
// src/utils/isPromise.ts
var hasPromise = (typeof Promise === "undefined" ? "undefined" : _type_of(Promise)) === FUNCTION;
var isPromise = function(value) {
    return hasPromise && _instanceof(value, Promise) || (isObject(value) || isFunction(value)) && isFunction(value.then);
};
// src/store/loadingStore.ts
import { applyMiddleware as applyMiddleware2, legacy_createStore as createStore3 } from "redux";
// src/middleware/loadingInterceptor.ts
var loadingInterceptor = function(loadingStore2) {
    return function() {
        return function(dispatch2) {
            return function(action) {
                if (!isLoadingAction(action)) {
                    return dispatch2(action);
                }
                var model = action.model, method = action.method, _action_payload = action.payload, category = _action_payload.category, loading = _action_payload.loading;
                if (loadingStore2.isModelInitializing(model)) {
                    loadingStore2.activate(model, method);
                } else if (!loadingStore2.isActive(model, method)) {
                    return;
                }
                var record = loadingStore2.getItem(model, method);
                if (!record || record.loadings.data[category] !== loading) {
                    return dispatch2(action);
                }
                return action;
            };
        };
    };
};
// src/middleware/destroyLoadingInterceptor.ts
var destroyLoadingInterceptor = function(api) {
    return function(dispatch2) {
        return function(action) {
            if (!isDestroyLoadingAction(action) || api.getState().hasOwnProperty(action.model)) {
                return dispatch2(action);
            }
            return action;
        };
    };
};
// src/store/loadingStore.ts
import { freeze as freeze2 } from "immer";
var findLoading = function findLoading(category) {
    return !!this.data[category];
};
var createDefaultRecord = function() {
    return {
        loadings: {
            find: findLoading,
            data: {}
        }
    };
};
var LoadingStore = /*#__PURE__*/ function(StoreBasic) {
    "use strict";
    _inherits(LoadingStore, StoreBasic);
    function LoadingStore() {
        var _this;
        _this = StoreBasic.call(this) || this;
        _this.initializingModels = [];
        _this.status = {};
        _this.defaultRecord = freeze2(createDefaultRecord(), true);
        var topic = modelStore.topic;
        topic.subscribe("init", _this.init.bind(_assert_this_initialized(_this)));
        topic.subscribe("refresh", _this.refresh.bind(_assert_this_initialized(_this)));
        topic.subscribe("unmount", _this.unmount.bind(_assert_this_initialized(_this)));
        topic.subscribe("modelPreInit", function(modelName) {
            _this.initializingModels.push(modelName);
        });
        topic.subscribe("modelPostInit", function(modelName) {
            _this.initializingModels = _this.initializingModels.filter(function(item) {
                return item !== modelName;
            });
        });
        return _this;
    }
    var _proto = LoadingStore.prototype;
    _proto.init = function init() {
        var middleware = [
            loadingInterceptor(this),
            destroyLoadingInterceptor
        ];
        if (process.env.NODE_ENV !== "production") {
            middleware.push(freezeStateMiddleware);
        }
        this.origin = createStore3(this.reducer.bind(this), applyMiddleware2.apply(null, middleware));
        combine(this.store);
    };
    _proto.unmount = function unmount() {
        this.origin = null;
    };
    _proto.reducer = function reducer(state, action) {
        if (state === void 0) {
            state = {};
        }
        if (isLoadingAction(action)) {
            var model = action.model, method = action.method, _action_payload = action.payload, category = _action_payload.category, loading = _action_payload.loading;
            var next = immer.produce(state, function(draft) {
                var _a2;
                draft[model] || (draft[model] = {});
                var loadings = ((_a2 = draft[model])[method] || (_a2[method] = createDefaultRecord())).loadings;
                loadings.data[category] = loading;
            });
            return next;
        }
        if (isDestroyLoadingAction(action)) {
            var next1 = Object.assign({}, state);
            delete next1[action.model];
            delete this.status[action.model];
            return next1;
        }
        if (isRefreshAction(action)) return {};
        return state;
    };
    _proto.get = function get(effect) {
        var _effect__ = effect._, model = _effect__.model, method = _effect__.method;
        var record;
        if (this.isActive(model, method)) {
            record = this.getItem(model, method);
        } else {
            this.activate(model, method);
        }
        return record || this.defaultRecord;
    };
    _proto.getItem = function getItem(model, method) {
        var level1 = this.getState()[model];
        return level1 && level1[method];
    };
    _proto.isModelInitializing = function isModelInitializing(model) {
        return this.initializingModels.length > 0 && this.initializingModels.includes(model);
    };
    _proto.isActive = function isActive(model, method) {
        var level1 = this.status[model];
        return level1 !== void 0 && level1[method] === true;
    };
    _proto.activate = function activate(model, method) {
        var _a2;
        ((_a2 = this.status)[model] || (_a2[model] = {}))[method] = true;
    };
    _proto.inactivate = function inactivate(model, method) {
        var _a2;
        ((_a2 = this.status)[model] || (_a2[model] = {}))[method] = false;
    };
    _proto.refresh = function refresh() {
        return this.dispatch(actionRefresh(true));
    };
    return LoadingStore;
}(StoreBasic);
var loadingStore = new LoadingStore();
// src/model/enhanceEffect.ts
var enhanceEffect = function(ctx, methodName, effect) {
    var fn = function fn() {
        return execute(ctx, methodName, effect, toArgs(arguments));
    };
    fn._ = {
        model: ctx.name,
        method: methodName,
        hasRoom: ""
    };
    var room = function(category) {
        return {
            execute: function execute1() {
                return execute(ctx, methodName, effect, toArgs(arguments), category);
            }
        };
    };
    room._ = Object.assign({}, fn._, {
        hasRoom: true
    });
    fn.room = room;
    return fn;
};
var dispatchLoading = function(modelName, methodName, loading, category) {
    loadingStore.dispatch({
        type: TYPE_SET_LOADING,
        model: modelName,
        method: methodName,
        payload: {
            category: category === void 0 ? LOADING_CATEGORY : category,
            loading: loading
        }
    });
};
var execute = function(ctx, methodName, effect, args, category) {
    var modelName = ctx.name;
    var resultOrPromise = effect.apply(ctx, args);
    if (!isPromise(resultOrPromise)) return resultOrPromise;
    dispatchLoading(modelName, methodName, true, category);
    return resultOrPromise.then(function(result) {
        return dispatchLoading(modelName, methodName, false, category), result;
    }, function(e) {
        dispatchLoading(modelName, methodName, false, category);
        throw e;
    });
};
// src/redux/createReducer.ts
var createReducer = function(options) {
    var allowRefresh = options.allowRefresh;
    var reducerName = options.name;
    var initialState = options.initialState;
    return function reducer(state, action) {
        if (state === void 0) return initialState;
        if (isPostModelAction(action) && action.model === reducerName) {
            return action.next;
        }
        if (isRefreshAction(action) && (allowRefresh || action.payload.force)) {
            return initialState;
        }
        return state;
    };
};
// src/utils/getter.ts
function composeGetter() {
    var args = toArgs(arguments);
    return args.reduce(function(carry, getter) {
        return getter(carry);
    }, args.shift());
}
var defineGetter = function(obj, key, get) {
    Object.defineProperty(obj, key, {
        get: get
    });
    return obj;
};
// src/utils/getMethodCategory.ts
var getMethodCategory = function(methodName) {
    return methodName.indexOf("_") === 0 ? "internal" : "external";
};
// src/model/guard.ts
var counter = {};
var guard = function(modelName) {
    counter[modelName] || (counter[modelName] = 0);
    if (process.env.NODE_ENV !== "production") {
        setTimeout(function() {
            --counter[modelName];
        });
    }
    if (++counter[modelName] > 1) {
        throw new Error("模型名称'" + modelName + "'被重复使用");
    }
};
// src/reactive/depsCollector.ts
var deps = [];
var level = -1;
var depsCollector = {
    get active () {
        return level >= 0;
    },
    produce: function produce(callback) {
        var current = deps[++level] = [];
        callback();
        deps.length = level--;
        var uniqueDeps = [];
        var uniqueID = [];
        for(var i = 0; i < current.length; ++i){
            var dep = current[i];
            var id = dep.id;
            if (uniqueID.indexOf(id) === -1) {
                uniqueID.push(id);
                uniqueDeps.push(dep);
                dep.end();
            }
        }
        return uniqueDeps;
    },
    append: function append(dep) {
        deps[level].push(dep);
    },
    prepend: function prepend(dep) {
        deps[level].unshift(dep);
    }
};
// src/reactive/ObjectDeps.ts
var ObjectDeps = /*#__PURE__*/ function() {
    "use strict";
    function _ObjectDeps(store, model, deps2) {
        if (deps2 === void 0) deps2 = [];
        this.store = store;
        this.model = model;
        this.deps = deps2;
        this.active = true;
        this.root = this.getState();
    }
    var _proto = _ObjectDeps.prototype;
    _proto.isDirty = function isDirty() {
        var rootState = this.getState();
        if (this.root === rootState) return false;
        var _this_getSnapshot = this.getSnapshot(rootState), pathChanged = _this_getSnapshot.pathChanged, nextSnapshot = _this_getSnapshot.snapshot;
        if (pathChanged || this.snapshot !== nextSnapshot) return true;
        this.root = rootState;
        return false;
    };
    _proto.start = function start(startState) {
        depsCollector.append(this);
        return this.proxy(startState);
    };
    _proto.end = function end() {
        this.active = false;
    };
    _proto.getState = function getState() {
        return this.store.getState()[this.model];
    };
    _proto.getSnapshot = function getSnapshot(state) {
        var deps2 = this.deps;
        var snapshot = state;
        for(var i = 0; i < deps2.length; ++i){
            if (!isObject(snapshot)) {
                return {
                    pathChanged: true,
                    snapshot: snapshot
                };
            }
            snapshot = snapshot[deps2[i]];
        }
        return {
            pathChanged: false,
            snapshot: snapshot
        };
    };
    _proto.proxy = function proxy(currentState) {
        var _loop = function(i) {
            var key = keys[i];
            Object.defineProperty(nextState, key, {
                enumerable: true,
                get: function() {
                    if (!_this.active) return currentState[key];
                    if (visited) {
                        return new _ObjectDeps(_this.store, _this.model, currentDeps.slice()).start(currentState)[key];
                    }
                    visited = true;
                    _this.deps.push(key);
                    return _this.proxy(_this.snapshot = currentState[key]);
                }
            });
        };
        var _this = this;
        if (currentState === null || !isObject(currentState) || Array.isArray(currentState)) {
            return currentState;
        }
        var nextState = {};
        var keys = Object.keys(currentState);
        var currentDeps = this.deps.slice();
        var visited = false;
        for(var i = keys.length; i-- > 0;)_loop(i);
        if (process.env.NODE_ENV !== "production") {
            Object.freeze(nextState);
        }
        return nextState;
    };
    _create_class(_ObjectDeps, [
        {
            key: "id",
            get: function get() {
                return this.model + "." + this.deps.join(".");
            }
        }
    ]);
    return _ObjectDeps;
}();
// src/model/defineModel.ts
import { freeze as freeze3, original, isDraft } from "immer";
// src/reactive/createComputedDeps.ts
import { shallowEqual } from "react-redux";
var createComputedDeps = function(body) {
    var snapshot;
    return {
        id: "c-" + body.model + "-" + body.property,
        end: function end() {
            snapshot = body.snapshot;
        },
        isDirty: function isDirty() {
            return !shallowEqual(snapshot, body.value);
        }
    };
};
// src/reactive/ComputedValue.ts
var ComputedValue = /*#__PURE__*/ function() {
    "use strict";
    function ComputedValue(store, model, property, fn) {
        this.store = store;
        this.model = model;
        this.property = property;
        this.fn = fn;
        this.deps = [];
    }
    var _proto = ComputedValue.prototype;
    _proto.isDirty = function isDirty() {
        if (!this.root) return true;
        var rootState = this.store.getState();
        if (this.root !== rootState) {
            var deps2 = this.deps;
            for(var i = deps2.length; i-- > 0;){
                if (deps2[i].isDirty()) return true;
            }
        }
        this.root = rootState;
        return false;
    };
    _proto.updateSnapshot = function updateSnapshot() {
        var _this = this;
        this.deps = depsCollector.produce(function() {
            _this.snapshot = _this.fn();
            _this.root = _this.store.getState();
        });
    };
    _create_class(ComputedValue, [
        {
            key: "value",
            get: function get() {
                if (this.active) {
                    throw new Error("[model:" + this.model + '] 计算属性"' + this.property + '"正在被循环引用');
                }
                this.active = true;
                this.isDirty() && this.updateSnapshot();
                this.active = false;
                if (depsCollector.active) {
                    depsCollector.prepend(createComputedDeps(this));
                }
                return this.snapshot;
            }
        }
    ]);
    return ComputedValue;
}();
// src/model/enhance-computed.ts
var enhanceComputed = function(ctx, modelName, computedName, fn) {
    var anonymousFn = function anonymousFn() {
        var args = toArgs(arguments);
        var hitCache;
        searchCache: for(var i = 0; i < caches.length; ++i){
            var cache2 = caches[i];
            if (hitCache) {
                ++cache2.skipCount;
                continue;
            }
            for(var j = 0; j < cache2.deps.length; ++j){
                if (args[j] !== cache2.deps[j]) {
                    ++cache2.skipCount;
                    continue searchCache;
                }
            }
            cache2.skipCount = 0;
            hitCache = cache2;
        }
        if (hitCache) return hitCache.ref.value;
        if (caches.length > 10) {
            caches = caches.filter(function(cache2) {
                return cache2.skipCount < 15;
            });
        }
        hitCache = {
            deps: args,
            skipCount: 0,
            ref: new ComputedValue(modelStore, modelName, computedName, function() {
                return fn.apply(ctx, args);
            })
        };
        caches.push(hitCache);
        return hitCache.ref.value;
    };
    var caches = [];
    return anonymousFn;
};
// src/model/defineModel.ts
var defineModel = function(uniqueName, options) {
    guard(uniqueName);
    var reducers = options.reducers, methods = options.methods, computed = options.computed, skipRefresh = options.skipRefresh, events = options.events;
    var initialState = process.env.NODE_ENV !== "production" ? freeze3(options.initialState, true) : options.initialState;
    if (process.env.NODE_ENV !== "production") {
        var items = [
            {
                name: "reducers",
                value: reducers
            },
            {
                name: "methods",
                value: methods
            },
            {
                name: "computed",
                value: computed
            }
        ];
        var validateUniqueMethod = function(index1, index2) {
            var item1 = items[index1];
            var item2 = items[index2];
            if (item1.value && item2.value) {
                Object.keys(item1.value).forEach(function(key) {
                    if (item2.value.hasOwnProperty(key)) {
                        throw new Error("[model:" + uniqueName + "] 属性'" + key + "'在" + item1.name + "和" + item2.name + "中重复使用");
                    }
                });
            }
        };
        validateUniqueMethod(0, 1);
        validateUniqueMethod(0, 2);
        validateUniqueMethod(1, 2);
    }
    if (process.env.NODE_ENV !== "production") {
        if (!deepEqual(parseState(stringifyState(initialState)), initialState)) {
            throw new Error("[model:" + uniqueName + "] initialState 包含了不可系列化的数据，允许的类型为：Object, Array, Number, String, Undefined 和 Null");
        }
    }
    var getState = function(obj) {
        return defineGetter(obj, "state", function() {
            var state = modelStore.getState()[uniqueName];
            return depsCollector.active ? new ObjectDeps(modelStore, uniqueName).start(state) : state;
        });
    };
    var getInitialState = function(obj) {
        return defineGetter(obj, "initialState", function() {
            return parseState(stringifyState(initialState));
        });
    };
    var actionCtx = composeGetter({
        name: uniqueName
    }, getInitialState);
    var createEffectCtx = function(methodName) {
        var isArrayState = Array.isArray(initialState);
        var obj = {
            // @ts-expect-error
            setState: enhanceAction(actionCtx, "" + methodName + ".setState", function(state, fn_state) {
                var nextState = isFunction(fn_state) ? fn_state(state) : fn_state;
                if (nextState === void 0) return;
                return isArrayState || isDraft(nextState) ? nextState : Object.assign({}, original(state), nextState);
            })
        };
        return composeGetter(Object.assign(obj, {
            name: uniqueName
        }), getState, getInitialState);
    };
    var enhancedMethods = {
        external: {},
        internal: {}
    };
    if (reducers) {
        var reducerKeys = Object.keys(reducers);
        for(var i = reducerKeys.length; i-- > 0;){
            var key = reducerKeys[i];
            enhancedMethods[getMethodCategory(key)][key] = enhanceAction(actionCtx, key, reducers[key]);
        }
    }
    if (computed) {
        var computedCtx = composeGetter({
            name: uniqueName
        }, getState);
        var computedKeys = Object.keys(computed);
        for(var i1 = computedKeys.length; i1-- > 0;){
            var key1 = computedKeys[i1];
            computedCtx[key1] = enhancedMethods[getMethodCategory(key1)][key1] = enhanceComputed(computedCtx, uniqueName, key1, // @ts-expect-error
            computed[key1]);
        }
    }
    if (methods) {
        var ctx;
        var ctxs = [
            ctx = createEffectCtx("")
        ];
        var methodKeys = Object.keys(methods);
        for(var i2 = methodKeys.length; i2-- > 0;){
            var key2 = methodKeys[i2];
            if (process.env.NODE_ENV !== "production") {
                ctxs.push(ctx = createEffectCtx(key2));
            }
            enhancedMethods[getMethodCategory(key2)][key2] = enhanceEffect(ctx, key2, // @ts-expect-error
            methods[key2]);
        }
        for(var i3 = ctxs.length; i3-- > 0;){
            Object.assign(ctxs[i3], enhancedMethods.external, enhancedMethods.internal);
        }
    }
    if (events) {
        var onInit = events.onInit, onChange = events.onChange, onDestroy = events.onDestroy;
        var eventCtx = Object.assign(composeGetter({
            name: uniqueName
        }, getState), enhancedMethods.external, enhancedMethods.internal);
        modelStore.onInitialized().then(function() {
            var subscriptions = [];
            if (onChange) {
                var prevState = eventCtx.state;
                subscriptions.push(modelStore.subscribe(function() {
                    var nextState = eventCtx.state;
                    if (modelStore.isReady && prevState !== nextState && nextState !== void 0) {
                        onChange.call(eventCtx, prevState, nextState);
                    }
                    prevState = nextState;
                }));
            }
            if (onDestroy) {
                subscriptions.push(modelStore.subscribe(function() {
                    if (eventCtx.state === void 0) {
                        for(var i = 0; i < subscriptions.length; ++i){
                            subscriptions[i]();
                        }
                        onDestroy.call(null, uniqueName);
                    }
                }));
            }
            if (onInit) {
                modelStore.topic.publish("modelPreInit", uniqueName);
                var promiseOrVoid = onInit.call(eventCtx);
                var postInit = function() {
                    modelStore.topic.publish("modelPostInit", uniqueName);
                };
                if (isPromise(promiseOrVoid)) {
                    promiseOrVoid.then(postInit, postInit);
                } else {
                    postInit();
                }
            }
        });
    }
    ModelStore.appendReducer.call(modelStore, uniqueName, createReducer({
        name: uniqueName,
        initialState: initialState,
        allowRefresh: !skipRefresh
    }));
    var model = Object.assign(composeGetter({
        name: uniqueName,
        _$opts: options,
        _$persistCtx: getInitialState({})
    }, getState), enhancedMethods.external);
    return model;
};
// src/model/cloneModel.ts
var editableKeys = [
    "initialState",
    "events",
    "persist",
    "skipRefresh"
];
var cloneModel = function(uniqueName, model, options) {
    var realModel = model;
    var prevOpts = realModel._$opts;
    var nextOpts = Object.assign({}, prevOpts);
    if (options) {
        Object.assign(nextOpts, isFunction(options) ? options(nextOpts) : options);
        if (process.env.NODE_ENV !== "production") {
            Object.keys(nextOpts).forEach(function(key) {
                if (nextOpts[key] !== prevOpts[key] && editableKeys.indexOf(key) === -1) {
                    throw new Error("[model:" + uniqueName + "] 复制模型时禁止重写属性'" + key + "'");
                }
            });
        }
    }
    return defineModel(uniqueName, nextOpts);
};
// src/model/useModel.ts
import { shallowEqual as shallowEqual2 } from "react-redux";
// src/redux/useSelector.ts
import { createSelectorHook } from "react-redux";
// src/redux/contexts.ts
import { createContext } from "react";
var ModelContext = createContext(// @ts-expect-error
null);
var LoadingContext = createContext(// @ts-expect-error
null);
var ProxyContext = createContext(// @ts-expect-error
null);
// src/redux/useSelector.ts
var useModelSelector = createSelectorHook(ModelContext);
var useLoadingSelector = createSelectorHook(LoadingContext);
// src/model/useModel.ts
function useModel() {
    var args = toArgs(arguments);
    var algorithm = args.length > 1 && isString(args[args.length - 1]) && args.pop();
    var selector = args.length > 1 && isFunction(args[args.length - 1]) && args.pop();
    var models = args;
    var modelsLength = models.length;
    var onlyOneModel = modelsLength === 1;
    if (!algorithm) {
        if (selector) {
            algorithm = "deepEqual";
        } else if (onlyOneModel) {
            algorithm = "strictEqual";
        } else {
            algorithm = "shallowEqual";
        }
    }
    var hasMemo = false, snapshot, prevState, currentStates, i, changed;
    var reducerNames = [];
    for(i = 0; i < modelsLength; ++i){
        reducerNames.push(models[i].name);
    }
    return useModelSelector(function(state) {
        if (hasMemo) {
            changed = false;
            for(i = modelsLength; i-- > 0;){
                var reducerName = reducerNames[i];
                if (state[reducerName] !== prevState[reducerName]) {
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                prevState = state;
                return snapshot;
            }
        }
        prevState = state;
        hasMemo = true;
        if (onlyOneModel) {
            var firstState = state[reducerNames[0]];
            return snapshot = selector ? selector(firstState) : firstState;
        }
        if (selector) {
            currentStates = [];
            for(i = modelsLength; i-- > 0;){
                currentStates[i] = state[reducerNames[i]];
            }
            return snapshot = selector.apply(null, currentStates);
        }
        snapshot = {};
        for(i = modelsLength; i-- > 0;){
            var reducerName1 = reducerNames[i];
            snapshot[reducerName1] = state[reducerName1];
        }
        return snapshot;
    }, compareFn[algorithm]);
}
var compareFn = {
    deepEqual: deepEqual,
    shallowEqual: shallowEqual2,
    strictEqual: void 0
};
// src/api/getLoading.ts
function getLoading(effect, category) {
    var args = arguments;
    if (effect._.hasRoom && !isFunction(category)) {
        var loadings = loadingStore.get(effect).loadings;
        return category === void 0 ? loadings : loadings.find(category);
    }
    for(var i = args.length; i-- > 0;){
        if (loadingStore.get(args[i]).loadings.find(LOADING_CATEGORY)) {
            return true;
        }
    }
    return false;
}
// src/api/useLoading.ts
function useLoading() {
    var args = arguments;
    return useLoadingSelector(function() {
        return getLoading.apply(null, args);
    });
}
// src/api/use-computed.ts
function useComputed(ref) {
    var args = toArgs(arguments, 1);
    return useModelSelector(function() {
        return ref.apply(null, args);
    });
}
// src/api/use-isolate.ts
import { useEffect, useMemo, useRef, useState } from "react";
var globalCounter = 0;
var hotReloadCounter = {};
var useIsolate = function(globalModel) {
    var _localModelRef_current;
    var initialCount = useState(function() {
        return globalCounter++;
    })[0];
    var uniqueName = process.env.NODE_ENV === "production" ? useProdName(globalModel.name, initialCount) : useDevName(globalModel, initialCount, new Error());
    var localModelRef = useRef();
    useEffect(function() {
        localModelRef.current = isolateModel;
    });
    var isolateModel = ((_localModelRef_current = localModelRef.current) == null ? void 0 : _localModelRef_current.name) === uniqueName ? localModelRef.current : cloneModel(uniqueName, globalModel);
    return isolateModel;
};
var useProdName = function(modelName, count) {
    var uniqueName = "@isolate:" + modelName + "#" + count;
    useEffect(function() {
        return function() {
            setTimeout(unmountModel, 0, uniqueName);
        };
    }, [
        uniqueName
    ]);
    return uniqueName;
};
var useDevName = function(model, count, err) {
    var componentName = useMemo(function() {
        try {
            var stacks = err.stack.split("\n");
            var innerNamePattern = new RegExp(// vitest测试框架的stack增加了 Module.
            "at\\s(?:Module\\.)?" + useIsolate.name + "\\s\\(", "i");
            var componentNamePattern = /at\s(.+?)\s\(/i;
            for(var i = 0; i < stacks.length; ++i){
                if (innerNamePattern.test(stacks[i])) {
                    return stacks[i + 1].match(componentNamePattern)[1];
                }
            }
        } catch (e) {}
        return "Component";
    }, [
        err.stack
    ]);
    var globalModelRef = useRef({
        count: 0
    });
    useEffect(function() {
        if (globalModelRef.current.model !== model) {
            globalModelRef.current = {
                model: model,
                count: ++globalModelRef.current.count
            };
        }
    });
    var uniqueName = "@isolate:" + model.name + ":" + componentName + "#" + count + "-" + (globalModelRef.current.count + Number(globalModelRef.current.model !== model));
    useMemo(function() {
        hotReloadCounter[uniqueName] || (hotReloadCounter[uniqueName] = 0);
        ++hotReloadCounter[uniqueName];
    }, [
        uniqueName
    ]);
    useEffect(function() {
        var prev = hotReloadCounter[uniqueName];
        return function() {
            setTimeout(function() {
                var unmounted = prev === hotReloadCounter[uniqueName];
                unmounted && unmountModel(uniqueName);
            });
        };
    }, [
        uniqueName
    ]);
    return uniqueName;
};
var unmountModel = function(modelName) {
    ModelStore.removeReducer.call(modelStore, modelName);
    loadingStore.dispatch({
        type: DESTROY_LOADING,
        model: modelName
    });
};
// src/redux/connect.ts
import { connect as originalConnect } from "react-redux";
var connect = function connect() {
    var args = toArgs(arguments);
    (args[3] || (args[3] = {})).context = ProxyContext;
    return originalConnect.apply(null, args);
};
// src/index.ts
import { compose as compose2 } from "redux";
// src/redux/FocaProvider.tsx
import { Provider } from "react-redux";
// src/persist/PersistGate.tsx
import { useState as useState2, useEffect as useEffect2 } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var PersistGate = function(props) {
    var state = useState2(function() {
        return modelStore.isReady;
    }), isReady = state[0], setIsReady = state[1];
    var _props_loading = props.loading, loading = _props_loading === void 0 ? null : _props_loading, children = props.children;
    useEffect2(function() {
        isReady || modelStore.onInitialized().then(function() {
            setIsReady(true);
        });
    }, []);
    if (process.env.NODE_ENV !== "production") {
        if (loading && isFunction(children)) {
            console.error("[PersistGate] 当前children为函数类型，loading属性无效");
        }
    }
    return /* @__PURE__ */ jsx(Fragment, {
        children: isFunction(children) ? children(isReady) : isReady ? children : loading
    });
};
// src/redux/FocaProvider.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var FocaProvider = function(param) {
    var children = param.children, loading = param.loading;
    return /* @__PURE__ */ jsx2(Provider, {
        context: ProxyContext,
        store: proxyStore,
        children: /* @__PURE__ */ jsx2(Provider, {
            context: LoadingContext,
            store: loadingStore,
            children: /* @__PURE__ */ jsx2(Provider, {
                context: ModelContext,
                store: modelStore,
                children: modelStore["persister"] ? /* @__PURE__ */ jsx2(PersistGate, {
                    loading: loading,
                    children: children
                }) : isFunction(children) ? children(true) : children
            })
        })
    });
};
// src/engines/local.ts
var local = {
    getItem: function getItem(key) {
        return localStorage.getItem(key);
    },
    setItem: function setItem(key, value) {
        localStorage.setItem(key, value);
    },
    removeItem: function removeItem(key) {
        localStorage.removeItem(key);
    },
    clear: function clear() {
        localStorage.clear();
    }
};
// src/engines/memory.ts
var cache = {};
var memoryStorage = {
    getItem: function getItem(key) {
        return cache[key] === void 0 ? null : cache[key];
    },
    setItem: function setItem(key, value) {
        cache[key] = value;
    },
    removeItem: function removeItem(key) {
        cache[key] = void 0;
    },
    clear: function clear() {
        cache = {};
    }
};
// src/engines/session.ts
var session = {
    getItem: function getItem(key) {
        return sessionStorage.getItem(key);
    },
    setItem: function setItem(key, value) {
        sessionStorage.setItem(key, value);
    },
    removeItem: function removeItem(key) {
        sessionStorage.removeItem(key);
    },
    clear: function clear() {
        sessionStorage.clear();
    }
};
// src/engines/index.ts
var engines = {
    /**
   * @deprecated 请直接使用浏览器内置的 localStorage
   */ localStorage: local,
    /**
   * 适用于测试的memoryStorage存储引擎
   *
   * @deprecated 请从foca直接引入
   * ```typescript
   * import { memoryStorage } from 'foca';
   * ```
   */ memoryStorage: memoryStorage,
    /**
   * @deprecated 请直接使用浏览器内置的 sessionStorage
   */ sessionStorage: session
};
export { FocaProvider, cloneModel, compose2 as compose, connect, defineModel, engines, getLoading, memoryStorage, modelStore as store, useComputed, useIsolate, useLoading, useModel };
//# sourceMappingURL=index.js.map